import * as React from 'react';

import ArrowFilledIcon from 'shared/newComponents/icons/ArrowFilledIcon';
import { IconStyle } from 'shared/entities/components/Icon';
import { PopupContainer } from 'shared/components/popups';
import {
  PopupEventType,
  PopupPosition
} from 'shared/entities/components/Popup';
import SelectorContent from 'shared/newComponents/form/Selector/Content';
import SelectorBaseContent from 'shared/newComponents/SelectorBase/Content';
import {
  SelectorKey,
  SelectorOptions,
  SelectorSize,
  SelectorType
} from 'shared/newEntities/components/Selector';
import { LoadingStage } from 'shared/entities/meta';
import { ComponentType } from 'shared/entities/components/Component';
import { TypographyColor } from 'shared/newEntities/components/Typography';

import BreadcrumbItem from '../BreadcrumbItem';

import './BreadcrumbSelectorItem.modules.scss';

const WIDTH = 216;

type Props = {
  children: React.ReactNode;
  to: string;
  mask: string;
  isActive?: boolean;
  className?: string;
  value: SelectorKey | null;
  options: SelectorOptions;
  onOptionClick: (value: string) => void;
  loadingStage?: LoadingStage;
  disabled?: boolean;
  showSelector?: boolean;
};

const BreadcrumbSelectorItem: React.FC<Props> = ({
  value,
  options,
  onOptionClick,
  loadingStage,
  isActive,
  children,
  disabled,
  className,
  showSelector = true,
  ...rest
}: Props) => {
  return (
    <div styleName="breadcrumb-selector-item" className={className}>
      <BreadcrumbItem
        action={{ type: ComponentType.link, ...rest }}
        isActive={isActive}
        disabled={disabled}
      >
        {children}
      </BreadcrumbItem>
      {showSelector && (
        <PopupContainer
          position={[PopupPosition.bottomCenter, PopupPosition.bottomRight]}
          on={PopupEventType.click}
          gap={6}
          closeOnDocumentClick={true}
          trigger={(isOpen) => {
            return (
              <div styleName="breadcrumb-selector-item__icon-wrapper">
                <ArrowFilledIcon
                  iconStyle={IconStyle.gray}
                  styleName="breadcrumb-selector-item__icon"
                  direction={isOpen ? 'top' : 'bottom'}
                />
              </div>
            );
          }}
        >
          {(onClose, isOpen) => {
            return (
              <SelectorBaseContent
                width={WIDTH}
                onClose={onClose}
                isOpen={isOpen}
              >
                {(onClose) => (
                  <SelectorContent
                    type={SelectorType.single}
                    withRemoving={false}
                    onClose={onClose}
                    value={value}
                    options={options}
                    loadingStage={loadingStage}
                    onOptionClick={onOptionClick}
                    selectorSize={SelectorSize.small}
                    fontColor={TypographyColor.secondary}
                  />
                )}
              </SelectorBaseContent>
            );
          }}
        </PopupContainer>
      )}
    </div>
  );
};

export default BreadcrumbSelectorItem;
